import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import styled from 'styled-components'
import { BasicButton } from 'ui/Buttons'
import { Modal } from 'ui/Modal'


const StyledDiv = styled.div`
    padding: 20px;
    h2{
     font-family: Montserrat Alternates-Bold;
    color: #909090;
    font-size: 24px;
    line-height: 29px;
    font-style: normal;
    margin-bottom: 0;
    display: inline-block;
    margin-bottom:20px;
    
    }

    p{
 
    font-family: Montserrat Alternates;
    font-size: 18px;
    line-height: 32px;
    color:#b5b5b5;
    margin-bottom:20px;
    }
    div{
        display: flex;
    gap: 10px;}
    `


const SaveModal = ({ show, close, submit, unblock, saved, location, edited }) => {
    const history = useHistory()
    // console.log('location---->', location, unblock)
    if (!show) return null;
    return (
        <Modal show={show} centered onHide={close} >
            <StyledDiv>
                <h2>Unsaved Changes</h2>
                <p>You have unsaved changes. If you leave this page, your changes will be lost. Are you sure you want to continue?</p>

                <div>
                    <BasicButton onClick={() => {
                        submit()
                        close()
                        saved(true)
                    }

                    }>
                        Save
                    </BasicButton>
                    <BasicButton onClick={() => {
                        if (unblock) unblock()
                            ; // Unblock navigation
                        edited(true)
                        history.push(location); // Navigate
                        close(); // Close modal


                    }}>
                        Discard
                    </BasicButton>
                </div>
            </StyledDiv>
        </Modal>
    )
}

export default SaveModal